import { filter, map, tap, Subject, Subscription } from 'rxjs';
import { sendCustomGAEvent } from './integrations';

export enum EventKey {
  LoginUser = 'LOGIN_USER',
  SubmitInspection = 'SUBMIT_INSPECTION',
}

export type BroadcastEvent = {
  key: EventKey;
  data?: any;
};

export class EventBus {
  private static instance?: EventBus;
  private eventBus = new Subject<BroadcastEvent>();

  public static getInstance(): EventBus {
    if (this.instance === undefined) {
      this.instance = new EventBus();
    }
    return this.instance;
  }

  on(key: EventKey, handler: (data: any) => void): Subscription {
    return this.eventBus
      .asObservable()
      .pipe(
        filter((event) => event.key === key),
        map((event) => event.data),
        tap(handler),
      )
      .subscribe();
  }

  broadcast(key: EventKey, data?: any): void {
    // TODO: add third party integrations based on which event is raised
    sendCustomGAEvent(key, data);
    this.eventBus.next({ key, data });
  }
}
